import React, { useContext, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { articleQueries } from '../../../../graphql/queries';
import HandDetails from './HandDetails.js';
import NotFoundMessage from '../../../../Components/Store/NotFoundMessage.js';
import LoadingScreen from '../../../../Components/LoadingScreen.js';
import {
  getNextHand,
  formatPathToArticleHandPlay
} from '../../../../helpers/hand.js';
import {
  HandContext,
  UserContext
} from '../../../../Context';
import { useHandAndParentQuery } from '../../../../Hooks';

const ArticleHandDetails = () => {
  let {
    articleId,
    handId
  } = useParams();

  handId = parseInt(handId);

  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const { init: initHandContext } = useContext(HandContext);

  const queryResponse = useHandAndParentQuery({
    handId,
    parentId: articleId,
    parentQuery: articleQueries.LatestArticleOrByPublicId
  });

  // useHandAndParentQuery only knows the queries resolved, not that the ids matched —
  // the inner hand/article are null for a bad deep link, so extract and guard them here.
  const article = queryResponse && queryResponse.parentData && queryResponse.parentData.latestArticleOrByPublicId;
  const hand = queryResponse && queryResponse.handData && queryResponse.handData.handById;

  const getNextHandUrl = useCallback((article) => {
    const nextHand = getNextHand(handId, article.hands);
    if (nextHand) {
      return formatPathToArticleHandPlay(article, nextHand);
    }
    return undefined;
  }, [handId]);

  useEffect(() => {
    if (article && hand) {
      initHandContext({
        hand,
        parent: article,
        grandParent: article.subscription,
        nextHandUrl: getNextHandUrl(article),
        currentUser: user
      });
    }
  }, [article, hand, initHandContext, getNextHandUrl, user]);

  if (!queryResponse) {
    return <LoadingScreen />;
  }

  if (!article || !hand) {
    return (
      <NotFoundMessage
        message='hand-not-found'
        actionLabel='browse-products'
        onAction={() => navigate('/products')}
      />
    );
  }

  return (
    <HandDetails />
  );
};

export default ArticleHandDetails;
